export const CRM_COUPON_TOKEN_PARAM = 'cpn';
